import { render, staticRenderFns } from "./SelectedTable.vue?vue&type=template&id=4f49f13b&scoped=true&"
import script from "./SelectedTable.vue?vue&type=script&lang=js&"
export * from "./SelectedTable.vue?vue&type=script&lang=js&"
import style0 from "./SelectedTable.vue?vue&type=style&index=0&id=4f49f13b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f49f13b",
  null
  
)

export default component.exports